import { logger } from '@/services/logger/loggers'
import { anonymizeTracking } from '@/services/tracking'
import { featureFlag } from '@/services/featureFlagProvider'
import { auth } from '@/modules/auth'

let logoutInFlight: Promise<void> | null = null

export const logout = async () => {
  if (logoutInFlight) {
    return logoutInFlight
  }

  logoutInFlight = (async () => {
    // 1. Clean up user identity in third-party providers (may clear cookies).
    //    Must happen before the Auth0 redirect, otherwise the page unloads
    //    before these calls complete.
    try {
      anonymizeTracking()
    } catch (error) {
      logger.error('[otters-shell - logout]: Failed to anonymize tracking', {
        error,
      })
    }

    try {
      await featureFlag.anonymize()
    } catch (error) {
      logger.error(
        '[otters-shell - logout]: Failed to anonymize feature flags',
        { error }
      )
    }

    // 2. Trigger Auth0 logout — this redirects the page to Auth0's /logout
    //    endpoint, which then redirects back to the app origin.
    try {
      if (auth.value) {
        await auth.value.logout()
      } else {
        logger.warn('[otters-shell - logout]: Auth module is not loaded', {})
        window.location.href = '/'
      }
    } catch (error) {
      logger.error('[otters-shell - logout]: Remote logout failed', { error })
      // Auth0 failed — reload to restore user session
      // (identity was already anonymized above).
      window.location.reload()
    }
  })().finally(() => {
    logoutInFlight = null
  })

  return logoutInFlight
}
